module.exports = __webpack_public_path__ + "img/logo_pololab.e720e21a.jpg";